<template>
  <page-edicion>
    <formulario-cliente
      :pais="pais"
      :cliente="cliente"
      :imagenes="imagenes"
      :contactos="contactos"
      @submit="insertar"
    />
  </page-edicion>
</template>

<script>
import FormularioCliente from "./FormularioCliente.vue";
import * as clienteApi from "@/services/clientes.js";

export default {
  components: { FormularioCliente },
  data() {
    return {
      cliente: clienteApi.crear(),
      imagenes: {},
      contactos: [],
      pais: {},
    };
  },
  methods: {
    insertar() {
      var data = {
        cliente: this.cliente,
        imagenes: this.imagenes,
        contactos: this.contactos,
      };
      clienteApi.insertar(data).then(() => {
        this.$router.push({ path: "/clientes" });
      });
    },
  },
};
</script>
